import React, { useEffect, useState } from 'react';
import TransactionDetails, { CategorizationModes } from '../../../transactions/components/TransactionDetails';
import { ITransaction, ITransactionDetailsMap } from '../../../../types';
import { getDetailsComponentsToShow, getExtendedTransaction } from '../../../transactions/utils';
import { useStore } from '../../../../store';

interface IProps {
  activeCard?: ITransaction;
  isReadOnly?: boolean;
}

export const CategorizeSummary = ({ activeCard, isReadOnly }: IProps) => {
  const [detailsComponentsMap, setDetailsComponentsMap] = useState<ITransactionDetailsMap | null>(null);
  const [extendedTransaction, setExtendedTransaction] = useState<{} | null>(null);
  const { user: { customerId }, getPrimaryAccount } = useStore(state => state);
  useEffect(() => {
    if (!activeCard) return;
    const map = getDetailsComponentsToShow(activeCard);
    if (map) {
      setDetailsComponentsMap(map);
    }

    getExtendedTransaction({ activeTransaction: activeCard, customerId, accountNo: getPrimaryAccount().achAccountNumber })
      .then(res => {
        setExtendedTransaction(res);
      });
  }, [activeCard]);

  return (
    <div className='fadeIn'>
      {extendedTransaction && detailsComponentsMap && (
      <TransactionDetails
        isReadOnly={isReadOnly}
        handleOnSuccessUpload={() => {}}
        detailsComponentsMap={detailsComponentsMap}
        detailsDataObject={extendedTransaction}
        categorizationMode={CategorizationModes.TRIGGER}
      />
      )}
    </div>
  );
};
